/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import renderHTML from 'react-render-html';

import AddFavorite from 'components/AddFavorite';
import Facts from 'components/Facts';

import StorageHandler from 'config/StorageHandler';

import { storageKeys } from 'settings';

const SpotifyPlayer = (props) => {
  const { links, width } = props;
  const parsedElements = [];

  links.forEach((link, i) => {
    const key = `${link}_${i}`;
    if (link.url.length > 0 && link.url.includes('spotify')) {
      parsedElements.push(<iframe key={key} title={link.url} src={link.url} height="500px" width={width} />);
    }
  });

  return parsedElements;
};

export default class TrainingText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: '',
    };
  }

  componentDidMount() {
    // const { appId, pageType, upID } = this.props;
    const { appId, pageType, contentComplete } = this.props;
    let { text } = this.props;
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = '';
      ({ email } = userObj);
      if (pageType !== 'Final-Page') {
        const anaUri = `https://crm.travpromobile.com/api/uri?email=${email}&app_id=${appId}&url=`;
        text = text.replace('href="', `href="${anaUri}`);
        text = text.replace(
          /href="/g,
          (
            (i) => (m) =>
              !i++ ? m : `href="${anaUri}`
          )(0),
        );
        text = text.split('<a').join('<a target="_blank"');
      }
      this.setState({ text });

      // const weblinks = text.getElementsByTagName('a');
      // for (let i = 0, len = weblinks.length; i < len; i++) {
      //   weblinks[i].target = '_blank';
      // }
    });

    contentComplete();
  }

  render() {
    const {
      appId,
      buttons,
      links,
      pageID,
      pageType,
      subtitle,
      title,
      type,
      upID,
      hideTitle,
      image,
      imageCredits,
      related_facts: relatedFacts,
    } = this.props;

    const { text } = this.state;

    return (
      <div className={`text__container ${pageType === 'Final-Page' ? 'wideFinalPage' : undefined}`} key={upID}>
        {buttons}
        {(pageType === 'Final-Page' || pageType === 'Introduction') && <div className="image" />}
        {!hideTitle && <h3 className={`pageTitle ${pageType === 'Final-Page' && 'finalPageTitle'}`}>{title}</h3>}
        <h4>{subtitle}</h4>
        {type === 'Spotify' && <SpotifyPlayer links={links} width="100%" />}
        <div className="bodyContent">
          {renderHTML(
            text
              .replace(/&lt;/g, '<')
              .replace(/&gt;/g, '>')
              .replace(/allowTransparency="[a-zA-Z0-9:;.s()\-,]*"/gi, '')
              .replace(/allowfullscreen/gi, 'allowFullScreen="allowFullScreen"')
              .replace(/ p>/g, '')
              .replace(/< \/p>/g, '')
              .replace(/< strong>/g, '')
              .replace(/ strong>/g, '')
              .replace(/<strong> /g, '<strong>'),
          )}
        </div>
        {<Facts appId={appId} image={image} imageCredits={imageCredits} relatedFacts={relatedFacts} />}
        {pageType !== 'Final-Page' && (
          <AddFavorite
            appId={appId}
            viewType="p"
            upID={upID}
            pageID={pageID}
            title={title}
            url="page"
            bgEnabled
            centered
          />
        )}
      </div>
    );
  }
}

TrainingText.propTypes = {
  buttons: PropTypes.oneOfType([PropTypes.object, PropTypes.element]),
  appId: PropTypes.number.isRequired,
  contentComplete: PropTypes.func,
  hideTitle: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  links: PropTypes.arrayOf(PropTypes.object),
  pageID: PropTypes.string,
  pageType: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  upID: PropTypes.string.isRequired,
  image: PropTypes.string,
  imageCredits: PropTypes.string,
  related_facts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      description: PropTypes.string.isRequired,
    }),
  ),
};

TrainingText.defaultProps = {
  buttons: [],
  contentComplete: () => {},
  hideTitle: false,
  links: [],
  pageID: '',
  subtitle: '',
  text: '',
  title: '',
  type: '',
  image: '',
  imageCredits: '',
  related_facts: [],
};
